import { CoOccurringDisorder, PrimaryFocus } from '../constant'
import { isNonEmptyArray } from '@/utils/checks'
export interface Center {
  _what_we_treat?: { title: string }[]
  what_we_treat?: string[]
  primaryFocus: string
}

const hasCoOccurringDisorders = (whatWeTreat: string[] | undefined): boolean =>
  !!whatWeTreat?.includes('Co-Occurring Disorders')

export const getCoOccurringDisorderLabel = (center: Center): string => {
  if (
    !center?.primaryFocus ||
    (!isNonEmptyArray(center?._what_we_treat) &&
      !isNonEmptyArray(center?.what_we_treat))
  )
    return ''

  const whatWeTreat =
    center?._what_we_treat?.map((item: { title: string }) => item?.title) ||
    center?.what_we_treat
  let coOccurringDisorder = ''

  switch (center?.primaryFocus) {
    case PrimaryFocus.SUBSTANCE_USE:
      coOccurringDisorder = hasCoOccurringDisorders(whatWeTreat)
        ? CoOccurringDisorder.MENTAL_HEALTH
        : ''
      break
    case PrimaryFocus.MENTAL_HEALTH:
      coOccurringDisorder = hasCoOccurringDisorders(whatWeTreat)
        ? CoOccurringDisorder.SUBSTANCE_USE
        : ''
      break
    default:
      break
  }

  return coOccurringDisorder
}
